<template>
    <div>
      <modal size="small">
          <div slot="header">Etes vous sûr de customiser ce joueur avec les éléments suivants ?</div>
          <div slot="body">
          <div class="row columns">
            <div class="large-12 columns">
              <template v-if="visibilities.stats">
                <table>
                  <thead class="roster-head">
                  <tr>
                    <th colspan="2">Modification de stats</th>
                  </tr>
                  </thead>
                  <tbody class="large-font">
                  <tr v-if="customisations.M !== 0">
                    <td width="10%">M.</td>
                    <td width="25%" class="stat">{{customisations.M}}</td>
                  </tr>
                  <tr v-if="customisations.F !== 0">
                    <td>F.</td>
                    <td class="stat">{{customisations.F}}</td>
                  </tr>
                  <tr v-if="customisations.Ag !== 0">
                    <td>Ag.</td>
                    <td class="stat">{{customisations.Ag}}</td>
                  </tr>
                  <tr v-if="customisations.Ar !== 0">
                    <td>Ar.</td>
                    <td class="stat">{{customisations.Ar}}</td>
                  </tr>
                  </tbody>
                </table>
              </template>
              <template v-if="visibilities.free_xp">
                <table>
                  <thead class="roster-head">
                  <tr>
                    <th>Xp gratuits</th>
                  </tr>
                  </thead>
                  <tbody class="large-font">
                    <td class="">{{customisations.free_xp}} xp</td>
                  </tbody>
                </table>
              </template>
              <template v-if="visibilities.skills">
                <table>
                  <thead class="roster-head">
                  <tr>
                    <th>Compétence Additionnelles</th>
                  </tr>
                  </thead>
                  <tbody class="large-font">
                  <tr v-for="skill in customisations.skills">
                    <td class="stat">{{getSkillName(skill)}}</td>
                  </tr>
                  </tbody>
                </table>
              </template>
              <template v-if="visibilities.xp">
                <table>
                  <thead class="roster-head">
                  <tr>
                    <th colspan="7">Nouvelles Actions à Xp</th>
                  </tr>
                  </thead>
                  <tbody class="large-font">
                    <tr>
                        <td>Reu.</td>
                        <td>Td.</td>
                        <td>Int.</td>
                        <td>Sor.</td>
                        <td>Mvp.</td>
                        <td>Bls.</td>
                        <td>Aggro.</td>
                    </tr>
                    <tr>
                      <td class="stat">{{customisations.nb_pass}}</td>
                      <td class="stat">{{customisations.nb_td}}</td>
                      <td class="stat">{{customisations.nb_int}}</td>
                      <td class="stat">{{customisations.nb_cas}}</td>
                      <td class="stat">{{customisations.nb_mvp}}</td>
                      <td class="stat">{{customisations.nb_foul}}</td>
                      <td class="stat">{{customisations.nb_niggling}}</td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <template>
                <table>
                  <thead class="roster-head">
                  <tr>
                    <th>Impact sur le coût du joueur & TV de l'équipe</th>
                  </tr>
                  </thead>
                  <tbody class="large-font">
                  <tr>
                    <td class="stat">{{customisations.additionnal_cost}} 000 pO</td>
                  </tr>
                  </tbody>
                </table>
              </template>
            </div>
          </div>
          </div>
          <div slot="footer" class="panel-footer" >
              <div class="row columns">
                <button class="large-4 light-grey-button" @click="$emit('closeMessage')">Annuler</button>
                <button class="large-4 large-offset-2 alert" @click="$emit('confirm')">Confirmer</button>
              </div>
          </div>
      </modal>
    </div>
</template>

<script>
import modal from '../../common/modal.vue'

export default {
  name: 'confirmModal',
  components: {
    modal
  },
  computed: {
    needStatRecap: function () {
      if ((this.customisations.M !== 0 && this.customisations.M) ||
          (this.customisations.F !== 0 && this.customisations.F) ||
          (this.customisations.Ag !== 0 && this.customisations.Ag) ||
          (this.customisations.Ar !== 0 && this.customisations.Ar)) {
        return true
      }
      return false
    }
  },
  props: {
    'customisations': {},
    'visibilities': {}
  },
  data () {
    return {
      showModal: false
    }
  },
  methods: {
    getSkillName (id) {
      return this.$store.getters.allSkillList.find(skill => { return skill.id === id }).name
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  thead tr th {
    background-color: #eaefea;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
  }

  tbody.large-font tr td{
    padding: 0.3rem 0.2rem;
    text-align: center;
    font-size:0.9rem;
  }
  tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
  }
</style>



// WEBPACK FOOTER //
// customisation-confirm-modal.vue?21923779